import React from "react";
import ReactModal, {
  Props as ReactModalProps,
  defaultStyles,
} from "react-modal";

const baseStyles = {
  content: {
    padding: 0,
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    border: "none",
  },

  overlay: {
    ...defaultStyles.overlay,
    backgroundColor: "rgba(0, 0, 0, 0.75)",
  },
};

const Modal = ({
  children,
  style,
  ...props
}: ReactModalProps & { children: React.ReactNode }) => {
  return (
    <ReactModal {...props} style={{ ...baseStyles, ...style }}>
      {children}
    </ReactModal>
  );
};

export default Modal;
